import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const NekoBusyOverlay = (props) => {
  const { spinner = true, busy = false, overlayStyle } = props;
  const [ showLoader, setShowLoader ] = useState(true);

  useEffect(() => {
    let timeout;

    // Show the loader
    if (!busy) { 
      timeout = setTimeout(() => { 
        setShowLoader(false); 
        timeout = null; 
      }, 250);
    }
    else { 
      setShowLoader(true);
    }

    // Cleanup
    return (() => {
      if (timeout) {
        clearTimeout(timeout);
      }
    });
  }, [busy]);

  const loader = !showLoader ? null : (
    <React.Fragment>
      <div className={'overlay' + ' ' + (!busy ? 'overlayHidden' : '')} style={overlayStyle}>
        {Boolean(spinner) && 
          <div className={'lds-ellipsis ' + (!busy ? 'spinnerHidden' : '')}>
            <div></div><div></div><div></div><div></div>
          </div>
        }
      </div>
      <style jsx>{`
        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          background: rgb(30 124 186 / 85%);
          transition: opacity 1s ease-out;
          z-index: 10;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          overflow: hidden;
        }

        .overlayHidden {
          opacity: 0;
          transition: opacity 0.25s ease-out;
        }
        .spinnerHidden {
          opacity: 0;
          transition: opacity 0.25s ease-out;
        }
        .lds-ellipsis {
          position: relative;
          width: 80px;
          height: 80px;
          display: flex;
          justify-items: center;
          align-items: center;
        }
        .lds-ellipsis div {
          position: absolute;
          width: 13px;
          height: 13px;
          border-radius: 50%;
          background: white;
          animation-timing-function: cubic-bezier(0, 1, 1, 0);
        }
        .lds-ellipsis div:nth-child(1) {
          left: 8px;
          animation: lds-ellipsis1 0.6s infinite;
        }
        .lds-ellipsis div:nth-child(2) {
          left: 8px;
          animation: lds-ellipsis2 0.6s infinite;
        }
        .lds-ellipsis div:nth-child(3) {
          left: 32px;
          animation: lds-ellipsis2 0.6s infinite;
        }
        .lds-ellipsis div:nth-child(4) {
          left: 56px;
          animation: lds-ellipsis3 0.6s infinite;
        }
        @keyframes lds-ellipsis1 {
          0% {
            transform: scale(0);
          }
          100% {
            transform: scale(1);
          }
        }
        @keyframes lds-ellipsis3 {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(0);
          }
        }
        @keyframes lds-ellipsis2 {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(24px, 0);
          }
        }        
      `}</style>
    </React.Fragment>
  );

  // I am removing the busy because I like it as a boolean...
  // ... but React doesn't like pure boolean value here.
  const propsForElement = { ...props, busy: undefined, spinner: undefined };
  return (
    <div style={{ position: 'relative' }} {...propsForElement}> 
      {loader}
      {props.children}
    </div>
  );
};

NekoBusyOverlay.propTypes = {
  busy: PropTypes.bool.isRequired,
  spinner: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default NekoBusyOverlay;